import { EMBED } from '@/constants/routes';
import { partnerThemes, type PackName } from '@/theme/partnerThemes';

import type { HirePortContextType } from '@/hooks/useHirePortContext';

const EMBED_RENDER_CUSTOM: HirePortContextType['renderCustom'] = {
  recruiterPublicProfile: {
    hideCandidateList: true,
  },
  recruiterSelection: {
    disableLinkToProfile: true,
  },
  jobEdit: {
    hideProgress: true,
  },
};

/** Pack-scoped HirePort context for ATS embed shells (theme + surface flags). */
export function buildEmbedHirePortContextValue(
  pack: PackName,
): Partial<HirePortContextType> {
  return {
    theme: partnerThemes[pack],
    urlBase: `${EMBED}/${pack}`,
    homePath: null,
    renderPageHeader: false,
    renderPageWrapper: false,
    atsType: pack,
    atsPostMessageStrategy: pack,
    renderCustom: EMBED_RENDER_CUSTOM,
  };
}
